import { cva } from 'class-variance-authority';

const buttonVariants = cva(
  'inline-flex shrink-0 items-center justify-center gap-2 rounded-md font-sans '
  + 'text-control-button whitespace-nowrap transition-colors '
  + 'focus-visible:shadow-focus focus-visible:outline-none '
  + 'disabled:pointer-events-none disabled:opacity-40',
  {
    variants: {
      variant: {
        'primary': 'bg-accent text-text-inverse hover:bg-accent-dark active:bg-accent-dark '
          + 'disabled:bg-accent-light disabled:opacity-100',
        'secondary': 'border-accent text-accent bg-surface border hover:bg-accent-tint',
        'neutral': 'border-border text-text-secondary bg-surface border hover:bg-surface-subtle',
        'destructive-outline': 'border-chip-danger-fg text-chip-danger-fg bg-surface border '
          + 'hover:bg-chip-danger-bg',
        'destructive-filled': 'bg-chip-danger-fg text-text-inverse',
        'ghost': 'text-text-muted bg-transparent hover:bg-surface-subtle',
      },
      size: {
        'sm': 'h-button px-3.5',
        'toolbar': 'px-4 py-1.75',
        'block': 'text-body h-input w-full px-4',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'sm',
    },
  },
);

export {
  buttonVariants,
};
